import {useTranslation} from '@aboutyou/i18n';
import {ResetFiltersButton} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {usePotentialFilters} from '../../ProductStream/utils';

export const ResetAllFilters: React.FC<{appliedFiltersCount: number}> = ({
  appliedFiltersCount,
}) => {
  const {t} = useTranslation();
  const {resetAllFilters} = usePotentialFilters();
  const noFilterApplied = appliedFiltersCount === 0;

  if (noFilterApplied) {
    return null;
  }

  return (
    <ResetAllButton
      dataTestId="resetAllFiltersButton"
      label={t('Reset all')}
      onReset={resetAllFilters}
    />
  );
};

const ResetAllButton = styled(ResetFiltersButton)`
  padding: 0;
  margin-left: 16px;
  &:first-child:last-child {
    margin-left: 0;
  }
`;
